import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";
import updateAccountSettings from "@store/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings"; // Poolcorp Custom Code

addToEndOfChain(chain, props => {
    props.dispatch(updateAccountSettings()); // Poolcorp Custom Import
});